<template>
  <div id="bbei">
    <el-card class="box-card newbb">
      <div slot="header" class="clearfix">
        <span>统计查询&nbsp;/&nbsp;报备统计</span>
      </div>
      <div>
        <Week @childFn="parentFn"></Week>
        <el-date-picker
          align="right"
          unlink-panels
          :picker-options="pickerOptions"
          v-model="zctime"
          style="margin: 0 26px 0 0"
          type="daterange"
          value-format="yyyy-MM-dd"
          @blur="time"
          range-separator="至"
          start-placeholder="报备开始日期"
          end-placeholder="报备结束日期"
        >
        </el-date-picker>
        <el-button
          type="primary"
          @click="query"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          >查询</el-button
        >
        <el-button type="info" @click="reset">重置</el-button>
      </div>
    </el-card>
    <el-card class="box-card bdechart">
      <div slot="header" class="clearfix">
        <span>区域：{{ seekCity }}</span>
        <Screendata @choice="timec"></Screendata>
      </div>
      <div class="overview">
        <p>
          <span>报备数</span
          ><span
            ><i class="mgr" id="time1">{{ statistics.bb  }}</i
            >次</span
          >
        </p>
        <p>
          <span>审核数</span
          ><span
            ><i class="mgr" id="time2">{{ statistics.sh  }}</i
            >次</span
          >
        </p>
        <p>
          <span>审核率</span
          ><span
            ><i>{{ statistics.shl }}</i></span
          >
        </p>
      </div>
      <div id="main1" style="width: 100%; height: 370px"></div>
    </el-card>
    <el-card class="box-card bdechart">
      <div slot="header" class="clearfix newbbtit">
        <span>报备统计明细表</span>
        <Xlsx :name="formname"></Xlsx>
      </div>
      <el-table
        :data="tableData6"
        id="exportTab"
        border
        stripe
        :row-class-name="tableRowClassName"
        style="width: 100%"
      >
        <el-table-column prop="areaName" width="200" label="区域"> </el-table-column>
        <el-table-column prop="total1" width="120" label="待审核">
        </el-table-column>
        <el-table-column prop="total2" width="120" label="已过期">
        </el-table-column>
        <el-table-column prop="total3" width="120" label="被驳回">
        </el-table-column>
        <el-table-column prop="total4" width="120" label="待检查">
        </el-table-column>
        <el-table-column prop="total5" width="120" label="检查合格">
        </el-table-column>
        <el-table-column prop="total6" width="120" label="检查不合格">
        </el-table-column>
        <el-table-column prop="total7" width="120" label="区域总报备">
        </el-table-column>
        <el-table-column width="120" prop="total9" label="过期率">
        </el-table-column>
        <el-table-column width="120" prop="total10" label="驳回率">
        </el-table-column>
        <el-table-column width="120" prop="total12" label="合格率">
        </el-table-column>
        <el-table-column width="120" prop="total11" label="不合格率">
        </el-table-column>
        <el-table-column width="120" prop="total8" label="审核率">
        </el-table-column>
      </el-table>
      <div class="paging">
        <span
          >共 <i class="pagingNum">{{ listnum }}</i> 条</span
        >
        <Paging :gopage="listnum" @pag="pag"></Paging>
      </div>
    </el-card>
  </div>
</template>
<script>
import Week from "@/components/Week";
import Screendata from "@/components/Screendata";
import echarts from "echarts";
import Xlsx from "@/components/Xlsx";
import Paging from "@/components/Paging";
export default {
  name: "bbei",
  components: {
    Week,
    Screendata,
    Xlsx,
    Paging,
  },
  data() {
    return {
      areaId: "",
      zctime: "",
      userdata: {},
      pageNum: 1,
      pageSize: 10,
      chart: [],
      total: {}, //总计
      tableData6: [],
      stat: "", //定义一个查询
      nowtime: "",
      listnum: 1,
      statistics: { bb: 0, sh: 0, shl: "0%" },
      formname: JSON.stringify({ name: "报备统计明细表", hint: "" }),
      fullscreenLoading: true,
      seekCity: "",
      level: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.load();
    this.seekCity = this.userdata.areasName;
  },
  mounted() {},
  methods: {
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.load(2);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.areaName == "合计") {
        return "re";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    timec(i) {
      this.fullscreenLoading = true;
      this.nowtime = i;
      this.stat = 1;
      this.load(2);
    },
    reset() {
      this.$router.push("/refresh");
    },
    load(type) {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = {};
      let url = "";
      let newar = "";
      let newtime = "";
      if (this.nowtime == "") {
        if (this.zctime == "") {
          newtime = "";
        } else {
          newtime = this.zctime.join(",");
        }
      } else {
        newtime = this.nowtime;
      }
      if (this.areaId == "") {
        newar = userdata.areasId;
        this.level = userdata.level;
        url = `/api-r/statistics/getReportStaticsData`;
      } else {
        newar = this.areaId;
        this.level = this.level;
        url = `/api-r/statistics/getReportStaticsData`;
      }
      if (this.stat == 1) {
        data = this.$qs.stringify({
          area: newar,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: newtime,
          level: this.level,
        });
      } else {
        data = this.$qs.stringify({
          area: userdata.areasId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: newtime,
          level: userdata.level,
        });
        // 初始接口
        url = `/api-r/statistics/getReportStaticsData`;
      }
      this.$axios
        .post(url, data, { headers: { accessToken: userdata.token } })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            this.$set(this, "chart", res.data.pageInfo.list);
            let arr = res.data.pageInfo.list;
            let obj = {
              areaName: "合计",
              total1: "",
              total2: "",
              total3: "",
              total4: "",
              total5: "",
              total6: "",
              total7: "",
              total8: "",
              total9: "",
              total10: "",
              total11: "",
              total12: "",
            };
            arr.forEach((x) => {
              let num = (Number(x.total5) + Number(x.total6)) / x.total7; //审核率
              let num3 = Number(x.total2) / x.total7; //过期率
              let num5 = Number(x.total3) / x.total7; //驳回率
              let num7 = Number(x.total6) / x.total7; //不合格率
              let num9 = Number(x.total5) / x.total7; //合格率
              if (num > 0) {
                x.total8 = Number(num * 100).toFixed(2) + "%";
              } else {
                x.total8 = 0;
              }
              if (num3 > 0) {
                x.total9 = Number(num3 * 100).toFixed(2) + "%";
              } else {
                x.total9 = 0;
              }
              if (num5 > 0) {
                x.total10 = Number(num5 * 100).toFixed(2) + "%";
              } else {
                x.total10 = 0;
              }
              if (num7 > 0) {
                x.total11 = Number(num7 * 100).toFixed(2) + "%";
              } else {
                x.total11 = 0;
              }
              if (num9 > 0) {
                x.total12 = Number(num9 * 100).toFixed(2) + "%";
              } else {
                x.total12 = 0;
              }
              obj.total1 = Number(obj.total1) + Number(x.total1);
              obj.total2 = Number(obj.total2) + Number(x.total2);
              obj.total3 = Number(obj.total3) + Number(x.total3);
              obj.total4 = Number(obj.total4) + Number(x.total4);
              obj.total5 = Number(obj.total5) + Number(x.total5);
              obj.total6 = Number(obj.total6) + Number(x.total6);
              obj.total7 = Number(obj.total7) + Number(x.total7);
              let num2 = Number(obj.total5 + Number(obj.total6)) / obj.total7;
              let num4 = Number(obj.total2) / obj.total7;
              let num6 = Number(obj.total3) / obj.total7;
              let num8 = Number(obj.total6) / obj.total7;
              let num10 = Number(obj.total5) / obj.total7;
              if (num2 > 0) {
                obj.total8 = Number(num2 * 100).toFixed(2) + "%";
              } else {
                obj.total8 = 0;
              }
              if (num4 > 0) {
                obj.total9 = Number(num4 * 100).toFixed(2) + "%";
              } else {
                obj.total9 = 0;
              }
              if (num6 > 0) {
                obj.total10 = Number(num6 * 100).toFixed(2) + "%";
              } else {
                obj.total10 = 0;
              }
              if (num8 > 0) {
                obj.total11 = Number(num8 * 100).toFixed(2) + "%";
              } else {
                obj.total11 = 0;
              }
              if (num10 > 0) {
                obj.total12 = Number(num10 * 100).toFixed(2) + "%";
              } else {
                obj.total12 = 0;
              }
            });
            arr.push(obj);
            this.$set(this, "tableData6", arr);
            this.$set(this, "listnum", res.data.pageInfo.total);
            if (type != 2) {
              this.$Public.NumAutoPlusAnimation("time1", {
                time: 1000, //总时间
                num: res.data.reportTotal , //结束数
                regulator: 8, //调速器
                count: 0,
              });
              this.$Public.NumAutoPlusAnimation("time2", {
                time: 1000, //总时间
                num: res.data.examineNum , //结束数
                regulator: 8, //调速器
                count: 0,
              });
              // this.$set(this, "total", res.data);
              setTimeout(() => {
                this.statistics.bb = res.data.reportTotal;
                this.statistics.sh = res.data.examineNum;
                this.statistics.shl = res.data.percentage;
              }, 4500);
            } else {
              document.getElementById("time1").innerHTML = res.data.reportTotal;
              document.getElementById("time2").innerHTML = res.data.examineNum;
              this.statistics.bb = res.data.reportTotal;
              this.statistics.sh = res.data.examineNum;
              this.statistics.shl = res.data.percentage;
            }
            if (this.stat == 1) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
            }
            this.seekCity = res.data.mergerName;
            let myChart1 = echarts.init(
              document.getElementById("main1"),
              "light"
            );
            let option = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                },
              },
              legend: {
                data: [
                  "待审核",
                  "已过期",
                  "被驳回",
                  "待检查",
                  "检查合格",
                  "检查不合格",
                ],
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              dataZoom: [
                {
                  type: "slider", //数据滑块
                  start: 0,
                  end: 80,
                  height: "10px",
                  minSpan: 8,

                  dataBackground: {
                    lineStyle: {
                      color: "#fff",
                    },
                    areaStyle: {
                      color: "#fff",
                      opacity: 1,
                    },
                  },
                },
                {
                  type: "inside", //使鼠标在图表中时滚轮可用
                },
              ],
              grid: {
                bottom: "75px",
              },
              xAxis: [
                {
                  type: "category",
                  data: [
                    "周一",
                    "周二",
                    "周三",
                    "周四",
                    "周五",
                    "周六",
                    "周日",
                  ],
                },
              ],
              yAxis: [
                {
                  type: "value",
                },
              ],
              series: [
                {
                  name: "待审核",
                  type: "bar",
                  stack: "广告",
                  data: [320, 332, 301, 334, 390, 330, 320],
                },
                {
                  name: "已过期",
                  type: "bar",
                  stack: "广告",
                  data: [120, 132, 101, 134, 90, 230, 210],
                },
                {
                  name: "被驳回",
                  type: "bar",
                  stack: "广告",
                  data: [220, 182, 191, 234, 290, 330, 310],
                },
                {
                  name: "待检查",
                  type: "bar",
                  data: [150, 232, 201, 154, 190, 330, 410],
                },
                {
                  name: "检查合格",
                  type: "bar",
                  data: [620, 732, 701, 734, 1090, 1130, 1120],
                },
                {
                  name: "检查不合格",
                  type: "bar",
                  stack: "广告",
                  data: [120, 132, 101, 134, 290, 230, 220],
                },
              ],
            };
            let arr1 = [];
            let arr2 = [];
            let arr3 = [];
            let arr4 = [];
            let arr5 = [];
            let arr6 = [];
            let arr7 = [];
            this.chart.forEach((x) => {
              arr1.push(x.areaName);
              arr2.push(x.total1);
              arr3.push(x.total2);
              arr4.push(x.total3);
              arr5.push(x.total4);
              arr6.push(x.total5);
              arr7.push(x.total6);
            });
            option.xAxis[0].data = arr1;
            option.series[0].data = arr2;
            option.series[1].data = arr3;
            option.series[2].data = arr4;
            option.series[3].data = arr5;
            option.series[4].data = arr6;
            option.series[5].data = arr7;
            myChart1.setOption(option);
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    parentFn(i) {
      this.areaId = i.id;
      this.level = i.level;
    },
    time() {
      console.log(this.zctime);
    },
    query() {
      this.fullscreenLoading = true;
      this.stat = 1;
      this.nowtime = "";
      this.load(2);
    },
  },
};
</script>
<style>
#bbei .newbb .el-card__body {
  display: flex;
  align-items: center;
}
#bbei .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
#bbei .el-table th > .cell {
  font-size: 14px;
  color: #666;
}
#bbei .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
/* #bbei .el-pagination{
        margin: 22px 0;
        float: right
    } */
#bbei .el-pagination__sizes .el-select {
  margin-top: -12px;
}
#bbei .el-table .re {
  color: #11A983;
  font-weight: 800;
}
#bbei .el-select > .el-input {
  margin: 0px 0 18px;
}
</style>
<style scoped lang="scss">
.bdechart {
  width: 100% !important;
  margin-top: 24px;
}
.overview {
  display: flex;
  // justify-content: space-around;
  text-align: center;
  border: 1px solid rgb(238, 238, 238);
  margin-bottom: 12px;
  & > p {
    width: 34%;
    border-right: 1px solid rgb(238, 238, 238);
  }
  & > p:nth-of-type(3) {
    width: 34%;
    border-right: none;
  }
  & > p > span {
    display: block;
    width: 100%;
    line-height: 20px;
    line-height: 50px;
    & > i {
      color: #11A983;
      font-size: 36px;
      font-weight: 600;
    }
  }
}
.newbbtit {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mgr {
  margin-right: 3px;
}
</style>
